var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('ul',_vm._l((_vm.tabs),function(tab,k){return _c('li',{key:k,on:{"click":function($event){return _vm.onClick(tab)}}},[_c('span',{class:{'active': tab.id === _vm.activeTab}},[_vm._v(_vm._s(tab.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }